import Icon from 'veui/components/Icon'
import { IconImageAdd } from 'dls-icons-vue'

Icon.register('image-add', IconImageAdd)
